export const getUrlParams = () => {
    let search = window.location.search;
    if (search[0] === '?') {
        search = search.slice(1, search.length)
    }
    const paramsList = search.split('&')
    const paramsKeyVal = {}
    try {
        paramsList.forEach(el => {
            const [key, value] = el.split('=')
            paramsKeyVal[key] = value
        })
        return paramsKeyVal

    } catch (e) {
        console.log('getUrlParams() error', e)
    }
}

export function removeParamFromUrl(parameter) {
    var url = document.location.href;
    var urlparts = url.split('?');

    if (urlparts.length >= 2) {
        var urlBase = urlparts.shift();
        var queryString = urlparts.join("?");

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = queryString.split(/[&;]/g);
        for (var i = pars.length; i-- > 0;)
            if (pars[i].lastIndexOf(prefix, 0) !== -1)
                pars.splice(i, 1);
        url = urlBase + '?' + pars.join('&');
        window.history.pushState('', document.title, url); // added this line to push the new url directly to url bar .

    }
    return url;
}

export const getUrlPath = () => window.location.pathname;
export const getUrlFullPath = () => window.location.href;
export const getUrlHostname = () => window.location.hostname;
export const getUrlProtocl = () => window.location.protocol;
